import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=a53d9038&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53d9038')) {
      api.createRecord('a53d9038', component.options)
    } else {
      api.reload('a53d9038', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=a53d9038&", function () {
      api.rerender('a53d9038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oaCHJgCVjl49/JS/videoIframe.vue"
export default component.exports